module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"columnSettings":"Column settings","groups":"Groups","columns":"Columns","checkAll":"Check all","searchColumn":"Search column"},"ru":{"columnSettings":"Настройки колонок","groups":"Группы","columns":"Колонки","checkAll":"Выбрать все","searchColumn":"Найти колонку"}}')
  delete Component.options._Ctor
}
